import { createStore, applyMiddleware, compose } from "redux";
import { syncHistoryWithStore } from "react-router-redux";
import { browserHistory } from "react-router";
import { persistStore, autoRehydrate } from "redux-persist";
import thunk from "redux-thunk";

import rootReducer from "./reducers/index";

const defaultState = {
  authentication: {
    user: null,
    isAuthenticated: false,
    error: null
  },
  events: [],
  students: [],
  measurements: []
};

const store = createStore(rootReducer, defaultState, compose(applyMiddleware(thunk), autoRehydrate()));

persistStore(store, {
  blacklist: ["events", "routing"]
});

export const history = syncHistoryWithStore(browserHistory, store);

export default store;



// WEBPACK FOOTER //
// ./store.js